module.exports = __webpack_public_path__ + "img/cl-install-hp-connectionRJ45_12200.3be4aeca.png";